module.exports = __webpack_public_path__ + "img/sticker_6.b96ecea4.svg";